

















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import routerSwitch from "@/services/RouteSwitch";
import { ThemeConfig } from "@/plugins/config";

const namespace: string = "authModule";

@Component({
  name: "sso",
})
export default class LoginSso extends Vue {
  @Getter("theme")
  public theme!: ThemeConfig;

  @Action("apiLogin", { namespace })
  private apiLogin!: (api_key: any) => Promise<void>;

  @Action("permissions", { namespace })
  private permissions!: () => Promise<void>;

  @Action("complete", { namespace })
  private complete!: () => Promise<void>;

  @Mutation("setLogout", { namespace })
  public setLogout!: any;

  private CLEVER_ERRORS = {
    "100": "Generic error (100)",
    "101": "CERT/Clever Connection error (101)",
    "102": "Student not found (102)",
    "103": "Student not found (103)",
    "104": "Your school have not enabled Clever Sync (104)",
    "105": "This user is registered as a student (105)",
    "106": "This Teacher/Admin could not be created (106)",
    "107": "This user is registered as a admin (107)",
    "108": "This student could not be updated (108)",
    "109": "School does not support your grade level (109)",
    "110": "There is an error on your account (110)",
    "111": "Student cannot be upgraded due to school restrictions (111)",
    "112": "Student grade not supported by CERT (112)",
    "113": "Student course not found (113)",
    "114": "School credits not available (114)",
    "115": "System error (115)",
    "116": "This student could not be created (116)",
    "117": "Student cannot be added due to school restrictions (117)",
    "118": "Invalid grade level (118)",
    "119":
      "The following student does NOT have an active account. Please contact your site administrator for further assistance (119)",
    "9998": "Please contact your site administrator for further information",
    "9999":
      "Access to your school's account begins with a purchase order. <a href='javascript:Intercom(\"show\");'>Click here to reach out to our sales team to reactivate your account</a>",
  };

  private isLoading = false;
  private httpReturnedObj: object = {};

  public async created() {
    //await this.setLogout();
  }

  public mounted() {
    const apiKey = this.$route.query.token;
    if (apiKey !== undefined) {
      this.signIn(apiKey);
    }
  }

  public async signIn(apiKey: any): Promise<void> {
    // Progress bar
    this.$Progress.start();
    try {
      this.isLoading = true;
      await this.apiLogin(apiKey);
      await this.permissions();
      this.$router.replace(routerSwitch.getRoute());
      this.$Progress.finish();
    } catch (e) {
      this.httpReturnedObj = e;
      this.isLoading = false;
      this.$Progress.fail();
    } finally {
      this.isLoading = false;
    }
  }

  get httpReturn() {
    return this.httpReturnedObj;
  }

  get loadingStatus() {
    return this.isLoading;
  }

  public async beforeDestroy() {
    await this.complete();
  }
}
